// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import DemoUserTable from './demo-table';
// assets
//

// ----------------------------------------------------------------------

export default function DemoAdmin() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <DemoUserTable />
        </Container >
    );
}
